<style src="./fonts/iconic/css/material-design-iconic-font.min.css"></style>
<style src="./css/login.css"></style>

<template>
	<div class="loginContainer circular">
		<div class="loginWrapper">
			<form class="login100-form validate-form">
				<span class="login100-form-logo">
					<img src="~@/assets/logo.jpeg" class="w-50" alt="logo">
				</span>

				<span class="login100-form-title py-5">
					Registrace
				</span>

				<div class="wrap-input100 validate-input" data-validate = "Zadejte uživatelské jméno">
					<input class="input100" type="text" name="username" v-model="username" placeholder="Uživatelské jméno">
					<span class="focus-input100"></span>
				</div>

				<div class="wrap-input100 validate-input" data-validate="Zadejte heslo">
					<input class="input100" type="password" name="pass" v-model="password" placeholder="Heslo">
					<span class="focus-input100"></span>
				</div>

				<div class="contact100-form-checkbox">
					<input class="input-checkbox100" id="ckb1" type="checkbox" name="remember-me">
					<label class="label-checkbox100" for="ckb1">
						Zůstat přihlášený
					</label>
				</div>

				<div class="container-login100-form-btn">
					<b-button variant="light" class="loginBtn" @click="login">Přihlásit</b-button>
				</div>

				<div class="text-center pt-5">
					<a class="bottomText mr-3" href="#">
						Zapomněli jste heslo?
					</a>
					<a class="bottomText" href="#">
						Registrace
					</a>
				</div>
			</form>
		</div>
	</div>
</template>

<script src="./js/login.js"></script>

<script>
	import AuthService from '@/services/AuthService.js';

    export default {
        data() {
            return {
                username: '',
                password: '',
				msg: ''
            };
        },
        methods: {
            async login() {
                try {
                    const credentials = {
                        username: this.username,
                        password: this.password
					};

                    const response = await AuthService.login(credentials);
                    this.msg = response.msg;
                    const token = response.token;
                    const user = response.user;
                    this.$store.dispatch('login', { token, user });
                    this.$router.push('/overview');
                } catch (error) {
                    this.msg = error.response.data.msg;
                }
            }
		}
    };
</script>